<!--  广告内容管理 -->
<template>
  <div class="content">
    <div class="header">

      <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">

        <el-row style="margin: 10px  0 10px">
          <el-form-item label="">
            <el-input v-model.trim="formTool.title" placeholder="请输入广告标题" clearable size="small" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model.trim="formTool.positionName" placeholder="请输入广告位名称" clearable size="small" />
          </el-form-item>

          <el-form-item label="">
            <el-select v-model="formTool.platform" clearable style="width: 160px;" size="small" placeholder="请选择平台端">
              <el-option v-for="item in sourceTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-select v-model="formTool.urlTypeId" clearable style="width: 160px;" size="small" placeholder="请选择链接类型">
              <el-option v-for="item in bannerTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="formTool.date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" size="small"
              :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期" />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="formTool.status" clearable style="width: 120px;" size="small" placeholder="请选择状态">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="addBanner">新增广告内容</el-button>
          </el-form-item>
        </el-row>

      </el-form>
    </div>

    <div class="center" style="position: relative">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
        <template slot="menu" slot-scope="scope">
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '下架')" class="btn-list"
            v-if="scope.row.status == 'PUBLISHED' || scope.row.status == 'AWAIT' ">下架</el-link>
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '详情')" class="btn-list"
            v-if="scope.row.status != 'REMOVAL' && scope.row.status != 'DRAFT'">详情</el-link>
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '发布')"
            v-if="scope.row.status != 'PUBLISHED'" class="btn-list">发布</el-link>
          <el-link :underline="false" type="primary" @click="detailHandle(scope.row, '编辑')" class="btn-list"
            v-if="scope.row.status != 'PUBLISHED'">编辑</el-link>
          <el-link :underline="false" type="primary" @click="changeStatusHandle(scope.row, '删除')"
            v-if="scope.row.status != 'PUBLISHED'" class="btn-list">删除</el-link>
        </template>

        <template slot="image" slot-scope="scope">
          <div style="display:column;align-items:center;justify-content: left;">
            <div style="width:100%;height:100%px;display:flex;align-items:left;justify-content:left;">
              <el-image style="width:80px;" :src="scope.row.image || avater"
                :preview-src-list="[scope.row.image || avater]" lazy />
            </div>
          </div>
        </template>
        <!-- filterBannerType -->
        <template slot="urlTypeId" slot-scope="scope">
          {{ scope.row.urlTypeId | filterBannerType }}
        </template>
        
        <template slot="platform" slot-scope="scope">
          {{ scope.row.platform | sourceType }}
        </template>
        <template slot="status" slot-scope="scope">
          <span v-if="scope.row.status == 'REMOVAL'" style="color:#F5222d">已下架</span>
          <span v-if="scope.row.status == 'PUBLISHED'" style="color:#67C23A">已发布</span>
          <span v-if="scope.row.status == 'AWAIT'" style="color:#E6A23C">待发布</span>
          <span v-if="scope.row.status == 'DRAFT'" style="color:#E6A23C">草稿</span>
        </template>

      </MyTable>
    </div>

    <addDialog ref="add-dialog" @getList="getList" />

  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import addDialog from "./components/addContent.vue";

import { mapGetters } from 'vuex'
import { positionSettingGetList, contentManagementGetPage, contentManagementDelete, publishOrRemoval } from "@/api/bannerManage";

import avater from "/public/img/default.png";
const bannerTypeOptions = [{
  value: '1',
  label: '商户店铺页'
},
{
  value: '2',
  label: '商品分类页'
},
{
  value: '3',
  label: '商品详情页'
},
{
  value: '4',
  label: '搜索结果页'
},
{
  value: '5',
  label: '特定商品搜索结果页'
},
{
  value: '6',
  label: '专栏页'
},
{
  value: '7',
  label: '文章页'
},
{
  value: '8',
  label: '活动页'
},
{
  value: '9',
  label: '链接地址'
},];
const sourceTypeOptions = [
  {
    value: 'MERCHANT_PC',
    label: '商户端(PC)'
  },
  {
    value: 'MERCHANT_APP',
    label: '商户端(APP)'
  },
  {
    value: 'CLIENT_PC',
    label: '客户端(PC)'
  },
  {
    value: 'CLIENT_APP',
    label: '客户端(APP)'
  },
  {
    value: 'CLIENT_MINI',
    label: '客户端(小程序)'
  },
  {
    value: 'BUSINESS_PC',
    label: '业务端PC'
  },
  {
    value: 'BUSINESS_APP',
    label: '业务端(APP)'
  },
];
const statusOptions = [
  
  {
    value: 'DRAFT',
    label: '草稿'
  },
  {
    value: 'AWAIT',
    label: '待发布'
  },
  {
    value: 'PUBLISHED',
    label: '已发布'
  },
  {
    value: 'REMOVAL',
    label: '已下架'
  },
];
export default {
  components: { MyTable, addDialog },
  data() {
    return {
      activeName: 'first',
      avater: avater,
      formTool: {
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [ 
        { label: "图片预览", prop: "image", slot: true }, 
        { label: "广告标题", prop: "title" },
        { label: "广告位名称", prop: "positionName" },
        { label: "平台端", prop: "platform", slot: true },
        { label: "链接类型", prop: "urlTypeId", slot: true },   
        { label: "发布时间", prop: "startTime" },
        { label: "结束时间", prop: "endTime" },
        { label: "广告位内排序", prop: "sort" },
        { label: "点击量", prop: "clickVolume" },
        { label: "发布人", prop: "updateBy" },
        { label: "状态", prop: "status", slot: true },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      sourceTypeOptions: sourceTypeOptions,
      statusOptions: statusOptions,
      bannerTypeOptions: bannerTypeOptions,
      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getList();
  },
  mounted() {
    
   },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  filters: {
    filterBannerType(e) {
      for (let i = 0; i < bannerTypeOptions.length; i++) {
        if (e == bannerTypeOptions[i].value) return bannerTypeOptions[i].label
      }
    },
    filterStatus(e) {
      for (let i = 0; i < statusOptions.length; i++) {
        if (e == statusOptions[i].value) return statusOptions[i].label
      }
    },
    sourceType(e) {
      for (let i = 0; i < sourceTypeOptions.length; i++) {
        if (e == sourceTypeOptions[i].value) return sourceTypeOptions[i].label
      }
    },
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    getHederHeight(){
      return this.$refs.formTool.$el.clientHeight; 
    },
    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1
    },

    detailHandle(row, btnType) {
      if (btnType == '编辑') {
        this.$refs['add-dialog'].init(row, 'edit')
      }
      if (btnType == '详情') {
        this.$refs['add-dialog'].init(row, 'detail')
      }
    },

    addBanner(row, btnType) {
      this.$refs['add-dialog'].init()
    },

    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList(current) {
      if (current) {
        this.page.current = current;
      }
      this.formTool.startTime = this.formTool.date?.[0] ?? '';
      this.formTool.endTime = this.formTool.date?.[1] ?? '';
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };

      // @Parameter(name = "clientTag",description = "客户端标识（app：app端，sell:卖家端, ops：ops端）"),
      contentManagementGetPage(params).then((res) => {
        if (res.records) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    // 勾选
    handleSelectionChange(val) {

    },
    changeStatusHandle(row, btnType) {
      this.$confirm(`确定要${btnType}【${row.title}】吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {};
          params.id = row.id;
          if (btnType == '发布') {
            params.status = 'PUBLISHED';
          }
          if (btnType == '下架') {
            params.status = 'REMOVAL';
          }
          if (btnType == '删除') {
            contentManagementDelete(row.id).then((res) => {
              if (res) this.$message.success('操作成功')
              this.getList()
            }).catch((err) => { })
          } else {
            publishOrRemoval(params).then((res) => {
              if (res) this.$message.success('操作成功')
              this.getList()
            }).catch((err) => { })
          }
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped>  
.content {
    height: calc(100% - 120px);

    .header {
      width: 100%;
      margin: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // padding: 0px 24px 0px 24px !important;
      border-bottom: 1px solid #f5f5f5;

      .font {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #262626;
      }

      .el-form-item {
        margin: 0px 0px 0px 8px !important;
      }
    }

    .center {
      margin-top: 16px;
      padding: 0 24px;
      height: calc(100% - 0px);
     

      .shangjia {
        position: absolute;
        z-index: 2;
        bottom: -45px;
      }
    }

    .btn-warp {
      display: flex;
      justify-content: space-around;

    }
  }

  .btn-list {
    margin: 0 10px;
  }
  ::v-deep .el-table{
    height: calc(100% - 120px)!important;
   overflow: auto;
  }
</style>
